import React, { useState } from 'react'
import Input from '../../../../../../../Components/CustomUi/input'
import { Select } from '../../../../../../../Components/CustomUi/Select'
import TextArea from '../../../../../../../Components/CustomUi/textarea'
import { faFlask, faFlaskVial, faIndustry, faTag } from '@fortawesome/free-solid-svg-icons'

interface Props {
  nome_produto: string
  setNome_produto: React.Dispatch<React.SetStateAction<string>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  setFabricante_id: React.Dispatch<React.SetStateAction<number>>
  tipo_aditivo: string
  setTipo_aditivo: React.Dispatch<React.SetStateAction<string>>
  setTipo_aditivo_id: React.Dispatch<React.SetStateAction<number>>
  tipo_formulacao: string
  setTipo_formulacao: React.Dispatch<React.SetStateAction<string>>
  setTipo_formulacao_id: React.Dispatch<React.SetStateAction<number>>
  modo_uso: string
  setModo_uso: React.Dispatch<React.SetStateAction<string>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  dataFabricante: any[]
  dataFormulacao: any[]
  dataTipoAditivos: any[]
}

export const Dados: React.FC<Props> = ({
  nome_produto,
  setNome_produto,
  fabricante,
  setFabricante,
  setFabricante_id,
  tipo_aditivo,
  setTipo_aditivo,
  setTipo_aditivo_id,
  tipo_formulacao,
  setTipo_formulacao,
  setTipo_formulacao_id,
  modo_uso,
  setModo_uso,
  observacao,
  setObservacao,
  dataFabricante,
  dataFormulacao,
  dataTipoAditivos,
}) => {
  const [openFabricante, setOpenFabricante] = useState<boolean>(false)
  const [openAditivo, setOpenAditivo] = useState<boolean>(false)
  const [openFormulacao, setOpenFormulacao] = useState<boolean>(false)
  console.log(dataTipoAditivos)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <Input
        label='Nome produto'
        icon={faTag}
        placeholder='Digite o nome do produto'
        value={nome_produto}
        onChange={setNome_produto}
        obrigatorio
      />
      <Select
        label='Fabricante'
        icon={faIndustry}
        value={fabricante}
        placeholder='Selecione o fabricante'
        onChange={setFabricante}
        onChangeID={setFabricante_id}
        open={openFabricante}
        trigger={setOpenFabricante}
        items={dataFabricante}
        descricaoItem={'nome'}
        idItem={'cod'}
        obrigatorio
      />
      <Select
        label='Tipo de aditivo'
        value={tipo_aditivo}
        icon={faFlaskVial}
        placeholder='Selecione o tipo de aditivo'
        onChange={setTipo_aditivo}
        onChangeID={setTipo_aditivo_id}
        open={openAditivo}
        trigger={setOpenAditivo}
        items={dataTipoAditivos}
        descricaoItem={'nome'}
        idItem={'cod'}
        obrigatorio
      />
      <Select
        label='Tipo de formulação'
        value={tipo_formulacao}
        icon={faFlask}
        placeholder='Selecione o tipo de formulação'
        onChange={setTipo_formulacao}
        onChangeID={setTipo_formulacao_id}
        open={openFormulacao}
        trigger={setOpenFormulacao}
        items={dataFormulacao}
        descricaoItem={'nome'}
        idItem={'cod'}
        obrigatorio
      />
      <div>
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: 5, marginBottom: '5px'}}>
          <label style={{ fontSize: '13px', fontWeight: '500' }}>Modo de uso</label>
          <p
              style={{
                margin: '0',
                padding: '0',
                fontSize: '11px',
                marginLeft: '3px',
                color: '#7B7B7B'
              }}
            >
              (obrigatório)
            </p>
        </div>
        <TextArea
          value={modo_uso}
          onChange={setModo_uso}
          maxHeight={100}
          maxLength={1500}
        />
      </div>

      <TextArea label='Observação' value={observacao} onChange={setObservacao} />
    </div>
  )
}
